import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { navigate } from 'gatsby';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation } from '@reach/router';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@mui/material/IconButton';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';

import { DocContext } from '../../../../DocMdx';
import { useTranslation, Trans, Translation } from 'react-i18next'

const useStyles = makeStyles(theme => ({
	navItemText: {
		wordBreak: 'break-word',
	  cursor: 'pointer',
	  '&:hover': {
	    textDecorationLine: 'underline',
	  },
	},

	navItemTextParent: {
	  cursor: 'pointer',
	  '&:hover': {
	    textDecorationLine: 'underline',
	  },
	  fontWeight: 'bold',
	},

	navItemTextCurrent: {
	  color: "#00adef",
	  cursor: 'pointer',
	  '&:hover': {
	    textDecorationLine: 'underline',
	  },
	  fontWeight: 'bold',
	},
}));

const DocNavItem = ({ nodes, label, path, uri }) => {
  const classes = useStyles();
  const loc = useLocation();
  const { lang } = React.useContext(DocContext);
  // const lang = dc.lang || 'en';
  if (!label && nodes) {
    let node = nodes.find(node => node?.fields?.path === path && node?.fields?.lang === lang);
    if (!node) node = nodes.find(node => node?.fields?.path === path);
    if (node) label = node.frontmatter.title;
  }
  if (!uri) uri = `/pipy/docs/${lang}/${path}`;
  let textClass = classes.navItemText;
  if (loc.pathname === uri) textClass = classes.navItemTextCurrent;
  else if (loc.pathname.startsWith(uri + '/')) textClass = classes.navItemTextParent;
	const navigateTo=(uri)=>{
		try{
			window.localStorage.setItem('scrollTop',document.querySelectorAll(".MuiDrawer-paperAnchorDockedLeft")[0].scrollTop)
		}catch{
		}
		navigate(uri)
	}
	
  return (
    <ListItem key={path} className={classes.navItem}>
      <ListItemText
        disableTypography
        className={textClass}
        primary={label}
        onClick={() => navigateTo(uri)}
      />
    </ListItem>
  );
}

const docNavGroupExpandState = {};

const DocNavGroup = ({ label, path, uri, children }) => {
  const { lang } = React.useContext(DocContext);
  const classes = useStyles();
  const loc = useLocation();
  const baseUri = uri || `/pipy/docs/${lang}/${path}`;
  let textClass = classes.navItemText, expand = false;
  if (loc.pathname === uri) {
    textClass = classes.navItemTextCurrent;
  } else if (loc.pathname.startsWith(baseUri + '/')) {
    textClass = classes.navItemTextParent;
    expand = true;
  }
  const [open, setOpen] = React.useState(Boolean(docNavGroupExpandState[path] || expand));
	const navigateTo=(uri)=>{
		try{
			window.localStorage.setItem('scrollTop',document.querySelectorAll(".MuiDrawer-paperAnchorDockedLeft")[0].scrollTop)
		}catch{
		}
		navigate(uri)
	}
  const handleClickExpand = () => {
    if (uri) navigateTo(uri);
    setOpen(!open);
    docNavGroupExpandState[path] = !open;
  }
  return (
    <React.Fragment>
      <ListItem key={path} className={classes.navItem}>
        <ListItemText
          disableTypography
          className={textClass}
          primary={label}
          onClick={handleClickExpand}
        />
        <IconButton size="small" onClick={handleClickExpand}>
          {open ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
        </IconButton>
      </ListItem>
      <Collapse in={open} style={{paddingLeft:10}}>
        <List dense disablePadding className={classes.navGroup}>
          {children}
        </List>
      </Collapse>
    </React.Fragment>
  )
}

const DocNavList = ({ nodes, prefix }) => {
  const { lang } = React.useContext(DocContext);
  const pages = nodes.filter(
    ({ fields, frontmatter: { api } }) => {
      if (!fields || !fields.path) return false;
      if (!fields.path.startsWith(prefix)) return false;
      if (api) {
        const i = api.lastIndexOf('.');
        if (i >= 0) {
          const head = api[i + 1];
          if (head.toLowerCase() === head) {
            let name = api.substring(0, i);
            let j = name.lastIndexOf('.');
            if (j >= 0) name = name.substring(j + 1);
          }
        }
      } else if (fields.lang !== lang) {
        return false;
      }
      return true;
    }
  );

  const tree = {};
  pages.forEach(
    (page, i) => {
      const path = page.fields.path.substring(prefix.length);
      const segs = path.split('/');
      const name = segs.pop();
      let t = tree;
      for (const s of segs) {
        if (s) {
          const c = t.children || (t.children = {});
          t = c[s] || (c[s] = {});
        }
      }
      const c = t.children || (t.children = {});
      t = c[name] || (c[name] = {});
      t.id = i;
    }
  );

  return <DocNavTree prefix={prefix} pages={pages} tree={tree}/>;
}

const DocNavTree = ({ prefix, pages, tree }) => {
  const { lang } = React.useContext(DocContext);
  const children = tree.children||{};
  return (
    Object.keys(children).sort().map(
      k => {
        const v = children[k];
        let path, uri, label = k;
        if (typeof v.id === 'number') {
          const page = pages[v.id];
          label = page.frontmatter.title;
          path = page.fields.path;
          uri = `/pipy/docs/${lang}/${path}`;
          const i = label.lastIndexOf('.');
          if (i >= 0 && !path.startsWith('release')) label = label.substring(i + 1);
        }
        if (v.children) {
          const path = `${prefix}/${k}`;
          return (
            <DocNavGroup key={path} label={label} path={path} uri={uri}>
              <DocNavTree prefix={path} pages={pages} tree={v}/>
            </DocNavGroup>
          );
        } else {
          return <DocNavItem key={path} label={label} path={path} uri={uri} />
        }
      }
    )
  );
}
const SidebarNav = ({ pages, onClose, crt,nodes }) => {
	setTimeout(()=>{
		try{
			document.querySelectorAll(".MuiDrawer-paperAnchorDockedLeft")[0].scrollTop = window.localStorage.getItem('scrollTop');
		}catch{
		}
	},0)
	
	let { t ,i18n} = useTranslation()
  const theme = useTheme();
  const [activeLink, setActiveLink] = useState('');
  const [current,setCurrent] = useState(crt||0);
  useEffect(() => {
    setActiveLink(window && window.location ? window.location.pathname : '');
  }, []);
  const handleClickExpand = (index) => {
    if(index == current) {
		setCurrent(-1);
	}else{
		setCurrent(index);
	}
  }
  return (
    <Box paddingBottom={2}>
      <Box
        justifyContent={'flex-end'}
        onClick={() => onClose()}
        display={{ xs: 'flex', md: 'none' }}
      >
        <CloseIcon fontSize="small" />
      </Box>
      <DocNavItem nodes={nodes} path="about-docs"/>
      <DocNavGroup label={t("Introduction")} path="intro">
        <DocNavItem nodes={nodes} path="intro/overview"/>
        <DocNavItem nodes={nodes} path="intro/concepts"/>
      </DocNavGroup>
      <DocNavGroup label={t("Getting Started")} path="getting-started">
        <DocNavItem nodes={nodes} path="getting-started/build-install"/>
        <DocNavItem nodes={nodes} path="getting-started/quick-start"/>
        <DocNavItem nodes={nodes} path="getting-started/getting-help"/>
      </DocNavGroup>
      <DocNavGroup label={t("Release")} path="release">
        <DocNavList nodes={nodes} prefix="release"/>
      </DocNavGroup>
      <DocNavGroup label={t("Tutorial")} path="tutorial">
        <DocNavList nodes={nodes} prefix="tutorial"/>
      </DocNavGroup>
      <DocNavGroup label={t("Operating")} path="operating">
        <DocNavList nodes={nodes} prefix="operating"/>
      </DocNavGroup>
      <DocNavGroup label={t("Reference")} path="reference">
        <DocNavList nodes={nodes} prefix="reference"/>
      </DocNavGroup>
    </Box>
  );
};

SidebarNav.propTypes = {
  crt: PropTypes.number,
  pages: PropTypes.array.isRequired,
  nodes: PropTypes.array,
  onClose: PropTypes.func,
};

export default SidebarNav;
